import React, { useState } from "react";
import { TextInput } from "../../../components";
import styles from "./LoginForm.module.css";

const LoginForm = ({ onSubmit, error, isLoading }) => {
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [emailError, setEmailError] = useState("");
	const [passwordError, setPasswordError] = useState("");

	const validateForm = () => {
		let isValid = true;

		// Validate email
		if (!email.trim()) {
			setEmailError("Email is required");
			isValid = false;
		} else if (!/\S+@\S+\.\S+/.test(email)) {
			setEmailError("Please enter a valid email");
			isValid = false;
		} else {
			setEmailError("");
		}

		// Validate password
		if (!password) {
			setPasswordError("Password is required");
			isValid = false;
		} else {
			setPasswordError("");
		}

		return isValid;
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		if (validateForm()) {
			onSubmit({ email, loginPassword: password });
		}
	};

	return (
		<div className={styles.formContainer}>
			<h2 className={styles.formTitle}>Sign In</h2>

			{error && <div className={styles.errorMessage}>{error}</div>}

			<form onSubmit={handleSubmit} className={styles.form}>
				<div className={styles.formGroup}>
					<TextInput
						type="email"
						label="Email"
						value={email}
						onChange={(e) => setEmail(e.target.value)}
						placeholder="Enter your email"
						error={emailError}
						disabled={isLoading}
						required
					/>
				</div>

				<div className={styles.formGroup}>
					<TextInput
						type="password"
						label="Password"
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						placeholder="Enter your password"
						error={passwordError}
						disabled={isLoading}
						required
					/>
				</div>

				<button
					type="submit"
					className={styles.submitButton}
					disabled={isLoading}
				>
					{isLoading ? "Signing in..." : "Sign In"}
				</button>
			</form>
		</div>
	);
};

export default LoginForm;
